export const DEFAULT_RECORDING_XP_KM_PER_POINT = Object.freeze({
  walk: 5,
  bike: 5,
});

export function normalizeRecordingXpMode(activityMode) {
  return String(activityMode || "").trim().toLowerCase() === "bike" ? "bike" : "walk";
}

export function normalizeKmPerXp(value, fallback = 5) {
  const number = Number(String(value ?? "").trim().replace(",", "."));
  if (!Number.isFinite(number) || number <= 0) return fallback;
  return Number(number.toFixed(3));
}

export function resolveRecordingKmPerXp(config, activityMode) {
  const mode = normalizeRecordingXpMode(activityMode);
  const fallback = DEFAULT_RECORDING_XP_KM_PER_POINT[mode];
  const source = config && typeof config === "object" ? config : {};
  return normalizeKmPerXp(
    mode === "bike" ? source.bikeKmPerXp : source.walkKmPerXp,
    fallback
  );
}
